<template>
  <div class="expense-form">
    <img src="@/assets/logo.png" alt="Logo" class="form-logo">
    <h1>Crear gasto</h1>
    <form @submit.prevent="submitExpense">
      <div class="form-group">
            <label for="nombreviaje">Nombre del viaje*</label>
            <input type="text" v-model="expense.nombreviaje" required/>
          </div>
      <div class="form-group date-input-container">
        <label for="fechainicioviaje">Fecha Inicio del Viaje*</label>
        <input type="date" id="fechainicioviaje" v-model="expense.fechainicioviaje" required @submit.prevent="submitExpense" />
        <span class="icon">📅</span>
      </div>
      <div class="form-group date-input-container">
        <label for="fechaterminoviaje ">Fecha Fin del Viaje*</label>
        <input type="date" id="fechaterminoviaje" v-model="expense.fechaterminoviaje" required @submit.prevent="submitExpense" />
        <span class="icon">📅</span>
      </div>
      <div class="form-group">
        <label for="tipogasto">Tipo de gasto*</label>
        <v-select 
          :options="tipogasto" 
          v-model="expense.tipogasto" 
          label="descripcion" 
          :reduce="tipo => tipo.id"
          @search="onTipoGastoSearch"
          @submit.prevent="submitExpense"/>
      </div>
      <div class="form-group">
        <label for="ciudad">Ciudades*</label>
        <v-select 
          :options="ciudades" 
          v-model="expense.ciudad" 
          multiple 
          label="nombreMunicipio"
          required 
          :reduce="ciudad => ciudad.id"
          @search="onCiudadSearch"
          @submit.prevent="submitExpense"/>
      </div>
      <div class="buttons">
        <button @click="reloadPage" class="fetch-btn fixed-button" type="submit">Crear gasto</button>
      </div>
      
    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {tokenValidation, selectDepartamentos, selectTiposGastos, OneDr} from '@/api/api';

export default {
  components: {
    vSelect
  },
  data() {
    return {
      expense: {
        nombreviaje: null,
        fechainicioviaje: null,
        fechaterminoviaje: null,
        ciudad: [],
        tipogasto: null,
      },
      tipogasto: [],
      ciudades: [],
      urlanexo: '',
      correousuario: '',
    };
  },
  mounted() {
    this.reloadPage();
    this.fetchCiudades();
    this.fecthTipoGastos();
  },
  created() {
    this.fetchCiudades();
  },
  methods: {
    resetForm() { // Borra los datos del formulario
      this.expense = {
        nombreviaje: '',
        fechainicioviaje: '',
        fechaterminoviaje: '',
        ciudad: [],
      };
      this.tipogasto = [];
      this.ciudades = [];
      this.urlanexo = [];
      this.reloadPage();
      this.fetchCiudades();
      this.fecthTipoGastos();
    },
    async reloadPage() { // Recarga la pagina en caso de que el token haya caducado
      
        let ValidToken = await tokenValidation();
      try {
        if(typeof(ValidToken.data) == undefined) {
          window.location.reload();
        } else {
          this.correousuario = ValidToken.data;
        }
      } catch (error) {
        console.error("Error al validar token", error);
        window.location.reload();
        }
      
    },
    async submitExpense() {
      if (!this.expense.nombreviaje || !this.expense.fechainicioviaje || !this.expense.fechaterminoviaje || !this.expense.tipogasto|| this.expense.ciudad.length === 0) {
        alert("Uno o mas campos obligatorios están sin diligenciar, revisar campos con *.")
      } else {
        let dateTimeActual = new Date(parseInt(Date.now(), 10));
        let expenseData = {
            title: 1,
            ...this.expense,
            fechaCreacion: dateTimeActual.toISOString(),
            fechaActualizacion: dateTimeActual.toISOString(),
            ciudades: this.expense.ciudad,
            correousuario: this.correousuario,
          };

        // Envía los datos al servidor
        try {
          const response = await OneDr(expenseData);
          if (response != undefined) {
            alert('Gasto creado con éxito');
            this.resetForm();
          }
        } catch (error) {
          console.error('Error al subir los gasto.', error);
          alert('Error al crear gasto');
        }
    }
    },
    async fetchCiudades(query = '') {
      try {
        const cachedData = localStorage.getItem("dataCities");
        if (cachedData) {
          this.ciudades = JSON.parse(cachedData).map(ciudad => ({id: ciudad.id, nombreMunicipio: ciudad.nombreMunicipio}));
        } else {
          localStorage.removeItem("dataCities");
          if (query.length >= 0) {
            try {
            const response = await selectDepartamentos(query);
            this.ciudades = response.data.map(ciudad => ({id: ciudad.codigomunicipio, nombreMunicipio: ciudad.nombredepartamento + ' - ' + ciudad.nombremunicipio}));

            // Guarda los datos en localStorage
            localStorage.setItem("dataCities", JSON.stringify(this.ciudades));
            } catch (err) {
              console.error('Error obteniendo las ciudades', err);
            }
          }
        }
      } catch (err) {
        console.error(err);
        window.location.reload();
      }
      
    },
    onCiudadSearch(search) {
      this.fetchCiudades(search);
    },
    async fecthTipoGastos(query = '') {
      try {
        const response = await selectTiposGastos(query);
        this.tipogasto = response.data.map(tipo => ({
          id: tipo.id,
          descripcion: tipo.descripcion,
        }));

        if (!this.expense.tipogasto && this.tipogasto.length > 0) {
          this.expense.tipogasto = this.tipogasto[3].id;
        }
      } catch (err) {
        console.error('Error obteniendo los tipos de gastos#', err);
      }
    },
    onTipoGastoSearch(search) {
      this.fecthTipoGastos(search);
    },
  },
};
</script>